import getScrollParent from './getScrollParent';

/**
 * Vertically Scrolls an element into view if it's not visible yet.
 * Replacement for native non-standard `scrollIntoViewIfNeeded`
 * function that doesn't have great browser support.
 *
 * @param {object} element - The element to be scrolled into view
 * @param {string} scrollBehavior - The element to be scrolled into view
 */

function scrollIntoViewIfNeeded(element, scrollBehavior) {
  if (!element) {
    return null;
  }
  var scrollParent = getScrollParent(element);
  var elementBounds = element.getBoundingClientRect();
  var scrollParentBounds = scrollParent.getBoundingClientRect();
  var elementTopEdge = elementBounds.top - scrollParentBounds.top;
  var elementBottomEdge = elementBounds.bottom - scrollParentBounds.top;
  var isElementTopHidden = elementTopEdge < 0 || elementTopEdge > scrollParent.clientHeight;
  var isElementBottomHidden = elementBottomEdge < 0 || elementBottomEdge > scrollParent.clientHeight;
  var doesElementFitInScrollParent = elementBounds.height < scrollParentBounds.height;
  if (isElementTopHidden || isElementBottomHidden && doesElementFitInScrollParent) {
    element.scrollIntoView({
      behavior: scrollBehavior
    });
  }
}
export default scrollIntoViewIfNeeded;